module.exports = require("@swa-ui/core/src/Shadow/Shadow.module.scss");